import React from 'react';

interface Props {
	size: number;
}

export const HealthcareIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>healthcare</title>
		<path d='M14.81 23.62H9.19v-8.81H.38V9.19h8.81V.38h5.62v8.81h8.81v5.62h-8.81zm-4.74-.88h3.86v-8.81h8.81v-3.86h-8.81V1.26h-3.86v8.81H1.26v3.86h8.81z' />
	</svg>
);
